import gql from 'graphql-tag'

export const companyDeleteUserAccess = gql`
  mutation companyDeleteUserAccess($companyId: ID!, $userId: ID!) {
    companyDeleteUserAccess(input: { companyId: $companyId, userId: $userId }) {
      success
    }
  }
`
